export default __webpack_public_path__ + "static/media/img2.bb002c47.png";